import React, { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import { useForm, SubmitHandler, set } from 'react-hook-form';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine, Label } from 'recharts';
import { useParams } from 'react-router-dom';
import getSensorKindName from '../Consts/getSensorKindName';
import Utility from 'Consts/Utility';
import { useCookies } from 'react-cookie';
import { useNavigate } from "react-router-dom"
import {ApiRequest} from "../Consts/ApiRequest";
import { modalProps } from '../Consts/constants';

type GraphInputs = {
    sensorId: string;
    setHistrical_start_date: string;
    setHistrical_end_date: string;
    yMin: string;
    yMax: string;
    datas: any[];
};

type Param = {
    siteId?: string,
    siteRecno?: string
    controlID?: string
}

type dashboardProps = {
    gatewayCtrlNo: string;
    childUnit: string;
    sensorValue: string;
}

export default function GraphModal(props: any) {

    const dateFormat = (date: Date) => {
        const currentYear = date.getFullYear();
        const currentMonth = String(date.getMonth() + 1).padStart(2, "0"); // 月を2桁にパディング
        const currentDay = String(date.getDate()).padStart(2, "0"); // 日を2桁にパディング
        const currentHours = String(date.getHours()).padStart(2, "0"); // 時を2桁にパディング
        const currentMinutes = String(date.getMinutes()).padStart(2, "0"); // 分を2桁にパディング
        return `${currentYear}/${currentMonth}/${currentDay} ${currentHours}:${currentMinutes}`;
    }

    const getStartDateString = (dates_number: number) => {
        const currentDate = new Date(); // 現在の日付と時刻を取得
        const twentyFourHoursAgo = new Date(currentDate.getTime() - 24 * 60 * 60 * 1000 * dates_number); // 24時間前の日付と時刻を計算
        return dateFormat(twentyFourHoursAgo);
    }

    const [histrical_start_date_buf, setHistricalStartDateBuf] = useState<string>("");
    const [histrical_end_date_buf, setHistricalEndDateBuf] = useState<string>(dateFormat(new Date()));

    const [histrical_start_date, setHistricalStartDate] = useState<string>("");
    const [histrical_end_date, setHistricalEndDate] = useState<string>(dateFormat(new Date()));

    const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);
    const navigate = useNavigate()

    const [yMin, setYMin] = useState<string>("");
    const [yMax, setYMax] = useState<string>("");

    const [xRange, setXRange] = useState<number>(0);
    const [xScale, setXScale] = useState<number>(0);
    const [yScale, setYScale] = useState<number>(0);
    const [yTicks, setYTicks] = useState<number[]>([]);

    const [xMaxVal, setXMaxVal] = useState<number>(0);
    const [xMinVal, setXMinVal] = useState<number>(0);

    const gatewayCtrlNo = props.gatewayCtrlNo;
    const childUnit = props.childUnit;
    const sensorValue = props.sensorValue;
    const sensorLabel = props.sensorLabel;

    const [upLimit, setUpLimit] = useState<number>(0);
    const [lowLimit, setLowLimit] = useState<number>(0);
    const [lowLowLimit, setLowLowLimit] = useState<number>(0);
    const [upUpLimit, setUpUpLimit] = useState<number>(0);
    const [error, setError] = useState<string[]>([]);

    const params: Param = useParams<Param>();
    const [open, setOpen] = useState(false);
    const [chartKey, setChartKey] = React.useState(0);
    const [dataArray, setDataArray] = useState<any[]>([]);
    const { register, handleSubmit, formState: { errors } } = useForm<GraphInputs>();
    const [counter, setCounter] = useState(60); // カウンターを60に初期化
    useEffect(() => {
    }, [open, dataArray]);


    useEffect(() => {
        if (!cookies.access_token) navigate("/login");
    }, []);

    useEffect(() => {
        if(Number(yMax) > Number(yMin)){
            let ticks = calcTicks(Number(yMin), Number(yMax), Number(yScale));
            setYTicks(ticks);
        }
    }, [yMin, yMax, yScale]);

    const resetData = (loadData = false) => {
        setError([]);
        setYMin("");
        setYMax("");
        setXRange(0);
        setXScale(1);
        setYScale(1);
        setYTicks([]);
        setXMaxVal(0);
        setXMinVal(0);
        setUpLimit(0);
        setLowLimit(0);
        setLowLowLimit(0);
        setUpUpLimit(0);
        setChartKey(0)
        setDataArray([]);
        setHistricalStartDateBuf("");
        setHistricalEndDateBuf(dateFormat(new Date()));
        setHistricalStartDate("");
        setHistricalEndDate(dateFormat(new Date()));
        if(loadData){
            fetchSensorSetting();
        }
    }
    const handleOpen = async () => {
        props.openCallback();
        setOpen(true);
        resetData(true);
    };
    const handleClose = () => {
        props.closeCallback();
        setOpen(false);
        resetData();
    }

    // TODO:関
    async function getGraphData(startDate: string, endDate: string, fetchYMin: string, fetchYMax: string) {
        let params = {
            siteId: props.siteId,
            histrical_start_date: startDate,
            histrical_end_date: endDate,
            yMax: Number(fetchYMax),
            yMin: Number(fetchYMin),
            gatewayRecno: props.gatewayRecno,
            sensorRecno: props.sensorRecno,
            sensorKind: props.sensorKind,
            childKind: props.childKind,
        };
        const token = cookies.access_token || "";
        setDataArray([]);
        ApiRequest.getGraphData(params, token, (response:any) => {
            console.log("getres");
            console.log(response);
            if(response.data.result == -1){
                console.log(response.data.messages);
                setDataArray([]);
                setError(response.data.messsages);
                return false;
            }else{
                setError([]);
            }
            setCounter(60);
            if (response.data.threhold) {
                const upUpLimit = response.data.threhold.upup;
                const upLimit = response.data.threhold.up;
                const lowLimit = response.data.threhold.low;
                const lowLowLimit = response.data.threhold.lowlow;
                setUpLimit(upLimit);
                setLowLimit(lowLimit);
                setLowLowLimit(lowLowLimit);
                setUpUpLimit(upUpLimit);
            }

            const rawData = response.data.datas;
            // const reducedData = rawData?.filter((_: number, index: number) => (index + 1) % 360 == 0);
            const reducedData = rawData;

            const rawDate = response.data.dates;
            // const reducedDate = rawDate?.filter((_: number, index: number) => (index + 1) % 360 == 0);
            const reducedDate = rawDate;

            setHistricalStartDate(startDate);
            setHistricalEndDate(histrical_end_date_buf);

            let dataArray: any[] = [];
            let xMax:number = 0;
            let xMin:number = 0;

            setDataArray([]);

            reducedData?.map((data: number, index: number) => {
                let date = new Date(reducedDate[index]).getTime();
                if(!xMax && !xMin) {
                    xMax = date;
                    xMin = date;
                }

                if(date > xMax) xMax = date;
                if(date < xMin) xMin = date;
                dataArray.push({ "data": reducedData[index], "date": new Date(reducedDate[index]).getTime() });
            });

            setXMaxVal(xMax);
            setXMinVal(xMin);

            setDataArray(dataArray);
            dataArray.reverse();
            setChartKey(Math.random());
        }, (error:any) => {
            console.log("error");
            errorCallback(error);
        })
    }

    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

    // モーダル表示時
    const fetchSensorSetting = async (rewrite: boolean = false) => {
        let params =                 {
            prcKind: 1,
            siteRecno: props.siteRecno,
            sensorRecno: props.sensorRecno,
            sensorId: props.sensorId,
            sensorName: props.sensorName,
            siteId: props.siteId,
        };
        try {
            const token = cookies.access_token || "";
            ApiRequest.getSensorSetting(params, token,
                (response: any) => {
                    let sensor = response.data.sensors.filter((e:any)=> {
                        return (e.childKind == props.childKind);
                    })[0];

                    let _yMin = sensor.graph.yMin ?? 0;
                    let _yMax = sensor.graph.yMax ?? 100;
                    let _xRange = sensor.graph.xRange ?? 1;
                    let _xScale = sensor.graph.xScale ?? 1;
                    let _yScale = sensor.graph.yScale ?? 1;

                    setXScale(_xScale);
                    setYScale(_yScale);

                    if(!rewrite){
                        setYMin(_yMin);
                        setYMax(_yMax);
                        setXRange(_xRange);
                        setHistricalStartDateBuf(getStartDateString(_xRange));
                        setHistricalStartDate(getStartDateString(_xRange));
                        let ticks = calcTicks(_yMin, _yMax, _yScale);
                        setYTicks(ticks);
                        getGraphData(
                            getStartDateString(_xRange),
                            dateFormat(new Date()),
                            _yMin,
                            _yMax);
                    }else{
                        getGraphData(
                            histrical_start_date_buf,
                            histrical_end_date_buf,
                            _yMin,
                            _yMax);
                    }

                }, (error:any) => {
                    errorCallback(error);
                })
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const calcTicks = (min:number, max:number, scale:number) => {
        let ticks = [];

        for(let i = 0; (i * scale + min) <= max; i++){
            // 最小と最大はここでは入れない
            let tick = i * scale + min;
            ticks.push(tick);
        }
        ticks.push(Number(min));
        ticks.push(Number(max));
        ticks.sort((a, b)=>(a - b));
        return ticks;
    };

    const filterData = () => {
        return dataArray.filter((elem) => {
            return elem.data > yMin;
        });
    }

    const calcXTicks = () =>{
        let ticks:number[] = [];
        let startDate = new Date(histrical_start_date);
        let endDate = new Date(histrical_end_date);

        for(let i = 0; startDate < endDate; startDate.setDate(startDate.getDate() +  (xScale ? xScale : 1))){
            ticks.push(startDate.getTime());
        }
        ticks.push(endDate.getTime());

        return ticks;
    };

    // 反映ボタン押下時
    const onSubmit = async () => {
        const newStartDate = Utility.formatDateTime(new Date(histrical_start_date_buf));
        const newEndDate = Utility.formatDateTime(new Date(histrical_end_date_buf));
        try {
            getGraphData(newStartDate, newEndDate, yMin, yMax);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    let beforeXLabel = "";

    return (
        <>
            {(() => {
                if (props.childName === '風向') {
                    return <a className="dashboard-box-item-data">
                        <div className="dashboard-box-item-data-name">
                            {props.childName}
                        </div>
                        <i className={props.iconName}></i>
                        <div className="dashboard-box-item-data-data">
                            {sensorValue}
                            <span>
                        {childUnit}
                    </span>
                        </div></a>
                } else if (props.childName === 'WBGT(暑さ指数)') {
                    return <a onClick={handleOpen} className="dashboard-box-item-data">
                        <div className="dashboard-box-item-data-name">
                            {props.childName}
                        </div>
                        <i className={props.iconName}></i>
                        <div className="dashboard-box-item-data-data" style={{ textAlign: "center" }}>
                            {sensorValue}
                            <span>
                                {childUnit}
                            </span>
                            <br />
                                {sensorLabel}
                        </div>
                    </a>
                } else {
                    return <a onClick={handleOpen} className="dashboard-box-item-data">
                        <div className="dashboard-box-item-data-name">
                            {props.childName}
                        </div>
                        <i className={props.iconName}></i>
                        <div className="dashboard-box-item-data-data">
                            {sensorValue}
                            <span>
                        {childUnit}
                    </span>
                        </div>
                    </a>
                }
            })()}
            <Modal {...modalProps} open={open} onClose={handleClose}>
                <div className="modal-wrapper" id="modal-chart">
                    <div className="modal modal-wide">
                        <div className="modal-header">
                            <div className="modal-title">
                                <div className="modal-title-withicon">
                                    <i className={props.iconName}></i>
                                    <span></span>
                                </div>
                                <div className="page-info-box">
                                    <div className="page-info-item">
                                        <span className="page-info-label">
                                            {getSensorKindName(props.sensorKind, props.childKind)} Gateway管理番号｜{gatewayCtrlNo}
                                        </span>
                                    </div>
                                    {/*<div className="page-info-status status-ok">稼働中</div>*/}
                                </div>
                            </div>
                            <a onClick={handleClose} className="modal-close"></a>
                        </div>

                        <div className="sort-box">
                            <div className="sort-box-group">
                                <span>対象期間</span>
                                <input
                                    type="datetime-local"
                                    value={Utility.formatDateTimeT(new Date(histrical_start_date_buf))}
                                    id=""
                                    name=""
                                    className="col-200"
                                    min="0000-01-01T00:00"
                                    max="9999-12-31T00:00"
                                    onChange={(e) => {
                                        setHistricalStartDateBuf(e.target.value)
                                    }}
                                />
                                <span>〜</span>
                                <input
                                    type="datetime-local"
                                    value={Utility.formatDateTimeT(new Date(histrical_end_date_buf))}
                                    id=""
                                    name=""
                                    min="0000-01-01T00:00"
                                    max="9999-12-31T00:00"
                                    className="col-200"
                                    onChange={(e) => {
                                        setHistricalEndDateBuf(e.target.value)
                                    }}
                                />
                                <div className="sort-box-btn">
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <button className="btn btn-white-line">
                                            <i className="icon-update-w">
                                            </i>反映
                                        </button>
                                    </form>
                                </div>
                                <span className="ml-20">有効幅</span>
                                <input
                                    type="text"
                                    value={yMin}
                                    id=""
                                    name=""
                                    className="col-120"
                                    onChange={(e) => setYMin(e.target.value)}
                                />
                                <span>{childUnit} 〜</span>
                                <input
                                    type="text"
                                    value={yMax}
                                    className="col-120"
                                    onChange={(e) => setYMax(e.target.value)}
                                />
                                <span>{childUnit}</span>
                            </div>
                        </div>

                        <div className="modal-body">
                            <div className="chart-box">
                                <br />
                                <div className="chart-body" style={{position: "relative"}}>
                                    {error ? <></> :
                                        <div
                                            style={{position: "absolute", top: '20px', left: '20px'}}>
                                            {getSensorKindName(props.sensorKind, props.childKind)}
                                            （Gateway管理番号｜{props.gatewayCtrlNo}）
                                        </div>
                                    }
                                    <div className="chart-chart" id="chart">
                                        {error.length > 0  ? <div className="chart-error">
                                                <i className="icon-l icon-caution-b"></i>
                                                <p dangerouslySetInnerHTML={{ __html: error.join("<br>") }} />
                                            </div> :
                                        <ResponsiveContainer width="100%" height="90%">
                                            <AreaChart
                                                key={chartKey}
                                                data={dataArray}
                                                margin={{
                                                    top: 10,
                                                    right: 30,
                                                    left: 0,
                                                    bottom: 0,
                                                }}
                                            >
                                                <CartesianGrid strokeDasharray="3 3" />

                                                <XAxis dataKey="date"
                                                    // interval={0}
                                                       type={"number"}
                                                       tick={{
                                                           fontSize: 12,
                                                       }}
                                                    // angle={-45}
                                                       ticks={
                                                           calcXTicks()
                                                       }
                                                       tickFormatter={(props) => {
                                                           if(props){
                                                               let date_str = new Date(props).toLocaleString();
                                                               let currentXLabel = Utility.ReformatDate(Utility.formatDateStrGraph(date_str));
                                                               // if(beforeXLabel == currentXLabel){
                                                               //     return "";
                                                               // }
                                                               beforeXLabel = currentXLabel;
                                                               return beforeXLabel;
                                                           }
                                                           return "";
                                                       }}
                                                       domain={[
                                                           (new Date(histrical_start_date)).getTime(),
                                                           (new Date(histrical_end_date)).getTime()
                                                       ]}
                                                >
                                                </XAxis>
                                                <YAxis key={chartKey}
                                                       tick={{
                                                           fontSize: 12,
                                                       }}
                                                       tickFormatter={(props) => {
                                                           return props + childUnit;
                                                       }}
                                                       ticks={yTicks}
                                                       allowDataOverflow={true}
                                                       domain={[Number(yMin) ?? "dataMin", Number(yMax) ?? "dataMax"]}
                                                />

                                                {/* 上限下限の設定 */}
                                                <ReferenceLine
                                                    y={upUpLimit}
                                                    stroke={props.childName === 'WBGT(暑さ指数)' && upUpLimit == 0 || upUpLimit == -100 ? "" : "red"}
                                                    strokeWidth={2}
                                                />
                                                <ReferenceLine
                                                    y={upLimit}
                                                    stroke={props.childName === 'WBGT(暑さ指数)' && upLimit == -100 ? "" : "orange"}
                                                    strokeWidth={2}
                                                />
                                                <ReferenceLine 
                                                    y={lowLimit}
                                                    stroke={props.childName === 'WBGT(暑さ指数)' ? "" : "lightblue"}
                                                    strokeWidth={2}
                                                />
                                                <ReferenceLine
                                                    y={lowLowLimit}
                                                    stroke={props.childName === 'WBGT(暑さ指数)' ? "" : "blue"}
                                                    strokeWidth={2}
                                                />
                                                <Tooltip
                                                    separator=""
                                                    labelFormatter={(value, name) => {
                                                        let datetime_str = new Date(Number(value)).toLocaleString();
                                                        return [datetime_str];
                                                    }}
                                                    formatter={(value, name) => {
                                                        let date_str = new Date(Number(name)).toLocaleDateString();
                                                        let currentXLabel = Utility.ReformatDate(Utility.formatDateStrGraph(date_str));
                                                        return [value + " " + childUnit, ""];
                                                    }} />
                                                <Area key={chartKey} type="linear" dataKey="data" stroke="#8884d8" fill="lightblue"
                                                      isAnimationActive={false}
                                                />
                                            </AreaChart>
                                        </ResponsiveContainer>
                                        }
                                    </div>
                                </div>
                                <div className="chart-list">

                                    <div className="chart-list-inner">
                                        <div className="chart-list-header">
                                            <span className="date">日時</span>
                                            <span className="val">計測値 ({childUnit})</span>
                                        </div>
                                        <div className="chart-list-body">
                                            {dataArray.map((dataobj) => {
                                                let color;
                                                let dataForColor;
                                                // 例: 80以上なら赤、60以上ならオレンジ（具体的な数値はお好みで調整してください）

                                                color = "black";  // それ以外の場合はデフォルトの黒
                                                dataForColor = dataobj.data * 1;

                                                if (props.childName === 'WBGT(暑さ指数)') {
                                                    // 1次上限値が-100（ほぼ安全）ではない場合かつ計測値が1次上限値よりも大きい場合にオレンジ色に変換
                                                    if (upLimit != -100 && dataForColor >= upLimit) {
                                                        color = "orange";
                                                        // 2次上限値が-100（ほぼ安全）ではない場合かつ0でない場合かつ計測値が2次上限値よりも大きい場合に赤色に変換
                                                        if (upLimit != -100 && upUpLimit != 0 && dataForColor >= upUpLimit) {
                                                            color = "red";
                                                        }
                                                    }
                                                } else {
                                                    if (dataForColor >= upLimit) {
                                                        color = "orange";
                                                        if (dataForColor >= upUpLimit) {
                                                            color = "red";
                                                        }
                                                    }
                                                    if (dataForColor <= lowLimit) {
                                                        color = "lightblue";
                                                        if (dataForColor <= lowLowLimit) {
                                                            color = "blue";
                                                        }
                                                    }
                                                }
                                                return (
                                                    <div key={new Date(dataobj.date).toLocaleString()} className="chart-list-data">
                                                        <span className="date">{new Date(dataobj.date).toLocaleString()}</span>
                                                        <span className="val" style={{ color: color }}>{dataobj.data} {childUnit}</span>
                                                    </div>
                                                );
                                            })}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal >
        </ >
    )
}
